import { Component, Input } from '@angular/core';

import { IconComponent } from '@atoms/icon/icon.component';

@Component({
  selector: 'app-content',
  imports: [IconComponent],
  templateUrl: './content.component.html',
  styleUrls: ['./content.component.scss'],
})
export class ContentComponent {
  @Input() size?: 'small' | 'small-medium' | 'medium' | 'large' | 'max' | 'full' = 'medium';
  @Input() gap?: 'small' | 'large' = 'large';
  @Input('plus-top') plusTop?: 'left' | 'right';
  @Input('plus-bottom') plusBottom?: 'left' | 'right';
}
